import { del } from '@si/utils';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

export function useLogoutAllSessions() {
  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: () => del({ url: '/user/account/sessions/logout-all' }),
  });

  const logoutAll = useCallback(() => mutate(), [mutate]);

  return { logoutAll, error, isPending, isSuccess, reset };
}
